import axios from '../../../axios';
import ICVView from '../type/ICVView';

const url = '/candidatesearch/api/';

export const trackCVView = (view: ICVView) => axios.post(`${url}cvview`, view);
